export default "__VITE_ASSET__ECiEBvlV__"